import { useQuery } from '@apollo/client'
import { useEffect } from 'react'

import { credentialsVar, loadingSessionStorage } from '../cache/auth'
import { ME_QUERY } from '../graphql/auth'
import { Credentials } from '../types/auth'

export const useBootstrapSession = () => {
  const { data, loading, error } = useQuery<{
    me: Credentials
  }>(ME_QUERY, {
    fetchPolicy: 'network-only'
  })

  useEffect(() => {
    if (!loading) {
      if (data?.me) {
        credentialsVar(data.me)
      }
      loadingSessionStorage(false)
    }
  }, [data, loading])

  useEffect(() => {
    if (error) {
      loadingSessionStorage(false)
    }
  }, [error])
}
